import { v4 as uuidv4 } from 'uuid';
export function createProject(data) {
    const now = new Date().toISOString();
    return {
        id: uuidv4(),
        name: data.name,
        description: data.description ?? null,
        priority: data.priority ?? 3,
        status: 'active',
        tags: data.tags ?? [],
        parent_id: data.parent_id ?? null,
        color: data.color ?? null,
        created_at: now,
        updated_at: now,
        completed_at: null,
    };
}
/**
 * Merge a stored Project with a partial change.
 *
 * The same contract as `applyTaskUpdate`, and here for the same reason: the
 * app spread `{ ...existing, ...data, updated_at }` inline in `useProjects`,
 * which works right up until a second caller does it slightly differently.
 *
 * Only keys actually PRESENT are applied. `undefined` means "not mentioned"
 * and leaves the stored value alone; `null` is a real value and clears the
 * field.
 *
 * `completed_at` is kept consistent with `status` rather than left to the
 * caller: a project marked completed gets a timestamp, and one moved back out
 * of completed has it cleared. Two callers remembering to do that by hand is
 * one caller forgetting.
 */
export function applyProjectUpdate(project, update, now) {
    const next = { ...project };
    for (const [key, value] of Object.entries(update)) {
        if (value === undefined)
            continue;
        // See applyTaskUpdate: this function is exported from core and the next
        // caller may hand it parsed JSON straight from the network.
        if (key === '__proto__' || key === 'constructor' || key === 'prototype')
            continue;
        next[key] = value;
    }
    if (update.status !== undefined && update.completed_at === undefined) {
        next.completed_at = update.status === 'completed' ? now : null;
    }
    next.updated_at = now;
    return next;
}
//# sourceMappingURL=project.js.map